import CheckMarkIcon from "@assets/icons/check-mark.svg";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { BackgroundIcon } from "@ui/components/common/background-icon";
import { Button } from "@ui/components/buttons/button";
import React from "react";
import CheckIcon from "@assets/icons/check.svg";
import { colors } from "@ui/style/colors";
import { ContactSupport } from "@ui/components/buttons/contact-support";
import { physioMeMobileBreakpoint, stack } from "@ui/style";
import { useDimensions } from "@ui/hooks/use-dimensions";

interface RegisterCompletedProps {
	onFinish: () => void;
}

export const RegisterCompletedStep = ({ onFinish }: RegisterCompletedProps): JSX.Element => {
	const { format } = useI18n();
	const { isMobile } = useDimensions();
	return (
		<Container>
			{isMobile && (
				<RowContactSupport>
					<SubnavigationContainer>
						<ContactSupport uiStyle="secondary" />
					</SubnavigationContainer>
				</RowContactSupport>
			)}
			<IconCompleted>
				<BackgroundIcon iconSvg={CheckMarkIcon} />
			</IconCompleted>
			<Header className="p-size-l-bold">{format("register.completed.pending.approval.header")}</Header>
			<Description>{format("register.completed.pending.approval.note1")}</Description>
			<Description>{format("register.completed.pending.approval.note2")}</Description>
			<Description>
				<IconContainer>
					<CheckIcon width={12} height={12} color={colors.primary} />
				</IconContainer>
				{format("register.completed.pending.approval.bullet1")}
			</Description>
			<Description>
				<IconContainer>
					<CheckIcon width={12} height={12} color={colors.primary} />
				</IconContainer>
				{format("register.completed.pending.approval.bullet2")}
			</Description>
			<StyledButton onClick={onFinish} label={format("global.close")} />
		</Container>
	);
};

const IconContainer = styled.div`
	width: 20px;
	height: 20px;
	border-radius: 10px;
	background-color: ${colors.primary10};
	display: inline-block;
	margin-right: 10px;
	padding-left: 4px;
`;

const IconCompleted = styled.div`
	place-items: center;
	display: grid;
`;

const Container = styled.div`
	display: grid;
	max-width: 448px;
	padding-left: 24px;
	padding-right: 24px;
`;

const RowContactSupport = styled.span`
	${stack(8, undefined, "stretch")}
	margin-bottom: 80px;
`;

const SubnavigationContainer = styled.span`
	align-self: start;
	position: absolute;
	top: 0px;
	right: 0px;

	@media ${physioMeMobileBreakpoint} {
		margin-top: 100px;
		margin-right: 16px;
	}
`;

const Header = styled.div`
	margin: 24px 0 16px;
`;

const Description = styled.div`
	margin-bottom: 16px;
	text-align: left;
`;

const StyledButton = styled(Button)`
	width: 100%;
	margin-top: 40px;
`;
